module.exports = __webpack_public_path__ + "static/media/get_started_2.90971742.png";